import { render, staticRenderFns } from "./CTextareaColumn.vue?vue&type=template&id=7ec15ef3"
import script from "./CTextareaColumn.vue?vue&type=script&lang=js"
export * from "./CTextareaColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ec15ef3')) {
      api.createRecord('7ec15ef3', component.options)
    } else {
      api.reload('7ec15ef3', component.options)
    }
    module.hot.accept("./CTextareaColumn.vue?vue&type=template&id=7ec15ef3", function () {
      api.rerender('7ec15ef3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CTextareaColumn.vue"
export default component.exports